exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".bd-l{border-left:1px solid #006fb9}.col-lg-6{padding-right:40px;padding-left:40px}", "", {"version":3,"sources":["C:/projects/Infrastil/evm/evm-frontend-react/src/pages/Home/Home.scss"],"names":[],"mappings":"AAEA,MACE,6BAA+B,CAAE,AAEnC,UACE,mBAAoB,AACpB,iBAAmB,CAAE","file":"Home.scss","sourcesContent":["/* COLOR PALETTE */\n/* SIZINGS */\n.bd-l {\n  border-left: 1px solid #006fb9; }\n\n.col-lg-6 {\n  padding-right: 40px;\n  padding-left: 40px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":false,"sourceMap":true,"minimize":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/pages/Home/Home.scss
// module id = 774
// module chunks = 0